export const fmtNum = (n: number | null | undefined): string =>
  n == null ? '—' : Math.round(n).toLocaleString('en-US')

/** A 0..1 ratio as a percentage with one decimal. */
export const fmtPct = (ratio: number | null | undefined): string =>
  ratio == null || !Number.isFinite(ratio) ? '—' : `${(ratio * 100).toFixed(1)}%`

/** Under an hour reads as minutes ("45 min"), otherwise hours with one decimal ("3.2 h"). */
export function fmtHours(h: number | null | undefined): string {
  if (h == null || !Number.isFinite(h)) return '—'
  if (h < 1) return `${Math.max(1, Math.round(h * 60))} min`
  return `${h.toFixed(1)} h`
}

/** Fractional change vs the previous window; null when there is no baseline to compare against. */
export function delta(current: number, previous: number | null | undefined): number | null {
  if (previous == null || previous === 0) return null
  return (current - previous) / previous
}

export function fmtDelta(d: number | null): string {
  if (d == null) return ''
  const pct = (d * 100).toFixed(1)
  return `${d > 0 ? '+' : ''}${pct}%`
}

export const ratio = (part: number, whole: number): number | null => (whole > 0 ? part / whole : null)

export const fmtDateTime = (iso: string | null | undefined): string => (iso ? new Date(iso).toLocaleString() : '—')
export const fmtDay = (iso: string | null | undefined): string => (iso ? new Date(iso).toLocaleDateString() : '—')

export function shortDay(day: string): string {
  const [, m, d] = day.slice(0, 10).split('-')
  return m && d ? `${Number(m)}/${Number(d)}` : day
}

export const SURFACE_LABELS: Record<string, string> = {
  share: 'Share links',
  preview: 'Preview links',
  esign: 'E-signature',
  embed: 'Embeds',
}

export const surfaceLabel = (s: string) => SURFACE_LABELS[s] ?? s

export const FORMAT_LABELS: Record<string, string> = {
  pdf: 'PDF', docx: 'Word (DOCX)', html: 'HTML', png: 'PNG', jpeg: 'JPEG', jpg: 'JPEG', txt: 'Text', md: 'Markdown',
}

export const formatLabel = (f: string) => FORMAT_LABELS[f.toLowerCase()] ?? f.toUpperCase()

export const capitalize = (s: string | null | undefined) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '—')
